import { Directive } from '@angular/core';

import { ANALYTICS_AREA } from '../../data';
import { UXArea } from '../../models';

import { AnalyticsAreaBase } from './analytics-area.base';

@Directive({
    selector: '[analyticsWidgetPopup]',
    providers: [
        {
            provide: ANALYTICS_AREA,
            useExisting: AnalyticsWidgetPopupDirective,
        },
    ],
})
export class AnalyticsWidgetPopupDirective extends AnalyticsAreaBase {
    type: UXArea = 'widget-popup';
}
